import axios, { AxiosResponse, AxiosError } from 'axios';
import { TransformRequest, TransformResponse, ApiError } from '../types';
import { APP_CONFIG, ERROR_MESSAGES } from '../utils/constants';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api/v1';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: APP_CONFIG.API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use(
  (config) => {
    config.params = {
      ...config.params,
      _t: Date.now(),
    };
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const apiError: ApiError = {
      message: ERROR_MESSAGES.NETWORK_ERROR,
      status: error.response?.status,
    };

    if (error.response?.data) {
      const errorData = error.response.data as any;
      apiError.message = errorData.error || ERROR_MESSAGES.SERVER_ERROR;
      apiError.code = errorData.code;
    } else if (error.code === 'ECONNABORTED') {
      apiError.message = 'Request timeout. Please try again.';
    } else if (!error.response) {
      apiError.message = ERROR_MESSAGES.NETWORK_ERROR;
    }

    return Promise.reject(apiError);
  }
);

export const transformText = async (
  text: string,
  turnstileToken: string
): Promise<TransformResponse> => {
  try {
    const requestData: TransformRequest = { text };
    const response = await apiClient.post<TransformResponse>(
      '/transform',
      requestData,
      { headers: { 'cf-turnstile-token': turnstileToken } }
    );
    return response.data;
  } catch (error) {
    const apiError = error as ApiError;
    return {
      success: false,
      error: apiError.message,
      code: apiError.code,
    };
  }
};

export default apiClient;
